<div *ngIf="loading" class="container d-flex align-items-center justify-content-center vh-100">
	<app-loading-spinner></app-loading-spinner>
</div>

<ng-container *ngIf="!loading">
	<div class="page-content mt-5 p-0" [ngClass]="questionnaire.lang_code === 'he' ? 'rtl' : 'ltr' ">
		<div class="container">
			<div class="card">
				<div class="card-header bg-primary">
					<h1 class="mb-0 text-light">{{ eula_submitted ? ('ASSESSMENTAPP.AUTH' | translate) : ('ASSESSMENTAPP.TERMS' | translate) }}</h1>
				</div>
				<div class="card-body">
					<div *ngIf="internal_loading" class="container d-flex align-items-center justify-content-center vh-50">
						<app-loading-spinner></app-loading-spinner>
					</div>
					<app-eula-agreement *ngIf="!internal_loading && !eula_submitted" #eulaAgreement></app-eula-agreement>
					<app-assessment-two-fa *ngIf="!internal_loading && eula_submitted"></app-assessment-two-fa>
				</div>
				<div *ngIf="!internal_loading && !eula_submitted" class="card-footer">
					<button class="btn btn-load btn-success" [ngClass]="questionnaire.lang_code === 'he' ? 'float-start' : 'float-end'" (click)="eula_submit()">
						<span class="d-flex justify-content-center">
							<span class="spinner-border" role="status" *ngIf="submitted && spinner">
								<span class="visually-hidden">Loading...</span>
							</span>
							<span [ngClass]="submitted && spinner ? 'ms-2' : ''">{{ 'ASSESSMENTAPP.ACCEPT' | translate }}</span>
						</span>
					</button>
					<p class="mb-0 w-75">
						<label class="list-group-item">
							<input class="form-check-input" [ngClass]="questionnaire.lang_code === 'he' ? 'ms-1' : 'me-1'" type="checkbox" [checked]="eula_checked" (change)="onCheckedDone()">
							<span class="ps-1 fs-16 text-secondary" style="font-weight: bold !important;">{{ 'ASSESSMENTAPP.READ_TERMS' | translate }}</span>
						</label>
					</p>
					<div *ngIf="!eula_checked && submitted" class="invalid-feedback d-block">{{ 'ASSESSMENTAPP.MUST_READ_TERMS' | translate }}</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>